import { faTableCellsLarge } from '@awesome.me/kit-b4fd369ea4/icons/classic/solid';
import { Box } from '@mui/material';
import { Title } from '../title/Title';
import { FrequentlyUsedWidget } from './widgets/FrequentlyUsedWidget';
import { RecentlyUsedWidget } from './widgets/RecentlyUsedWidget';

export const Home = () => {
  return (
    <>
      <Title title="Home" icon={faTableCellsLarge} />
      <Box sx={{ p: 2, display: 'grid', gap: 2, gridTemplateColumns: 'repeat(auto-fill, minmax(420px, 1fr))' }}>
        <RecentlyUsedWidget />
        <FrequentlyUsedWidget />
      </Box>
    </>
  );
};
